import type { DistrictMiniEntity } from '@/features/branch/domain/entities/DistrictMiniEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class CampaignRegionsEntity {
  region?: RegionMiniEntity | null
  districts?: Array<DistrictMiniEntity> | null
  districtIds?: Array<number> | null
}
